import { jsx as _jsx } from "react/jsx-runtime";
import { Alert, Snackbar } from "__barrel_optimize__?names=Alert,Snackbar!=!@mui/material";
const SnackBar = (param)=>{
    let { open, handleClose, type, duration, children } = param;
    return /*#__PURE__*/ _jsx(Snackbar, {
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "center"
        },
        open: open,
        autoHideDuration: duration || 6000,
        onClose: handleClose,
        children: /*#__PURE__*/ _jsx(Alert, {
            onClose: handleClose,
            severity: type,
            sx: {
                width: "100%"
            },
            children: children
        })
    });
};
export default SnackBar;
